module.exports = __webpack_public_path__ + "static/data-bg.5e3d972a.png";